import { Component, OnInit ,HostListener } from '@angular/core';
import { ChartData, ChartEvent, ChartType } from 'chart.js';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { environment } from '../../../environments/environment';
declare var $:any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {

  public audiopath:any='';
  public showButton:boolean=true;

  public doughnutChartPlugins: any=[];

  public data:any = [];

//Initializing Legend
public legendSettings: Object = {
    visible: false,
};
//Initializing DataLabel
public dataLabel: Object = {
    visible: true,
    name: 'DataLabelMappingName',
    position: 'Outside',
    font: {
        fontWeight: '600',
    },
    connectorStyle: { 
        length: '20px',
        type: 'Curve'
     },
};

public border: object = {
    width: 1
};
 // custom code start

 // custom code end

  public loading:boolean = true;
  public firstview:boolean = false;
  public detaildata:any=[];
  public ssvalue:any='00.00';
  public ppvalue:any='00.00';
  public rrvalue:any='00.00';
  public isBunnyVideo(url: any): boolean {
    const value = String(url || '');
    return value.includes('iframe.mediadelivery.net') || value.includes('/embed/');
  }
  public chartShow:boolean=false;
  public AlbumList:any =[];
  public b_AlbumList:any=[];
  public doughnutChartData: any = {
    type: 'doughnut',
    labels: [ ],
    datasets: [
      { data: [] }
    ], 
    option:{
        plugins: {
          datalabels: {
            formatter: (value:any) => {
              return  '$'+value ;
            },
            display: true,
            backgroundColor: '#ccc',
            borderRadius: 3,
            font: {
              color: 'red',
              weight: 'bold',
            },
          },
          doughnutlabel: {
            labels: [
              {
                text: '',
                font: {
                  size: 20,
                  weight: 'bold',
                },
              },
              {
                text: 'total',
              },
            ],
          },
        },
    }   
  };

  public centerText: String = "Center Text";
  public chartOptions: any & { annotation: any }= {
    centerText: this.centerText,
    plugins: {
      datalabels: {
        formatter: (value:any) => {
          return  '$'+value ;
        },
        display: true,
        backgroundColor: '#ccc',
        borderRadius: 3,
        font: {
          color: 'red',
          weight: 'bold',
        },
      },
      doughnutlabel: {
        labels: [
          {
            text: '',
            font: {
              size: 20,
              weight: 'bold',
            },
          },
          {
            text: 'total',
          },
        ],
      },
    },

  };
  
  public doughnutChartType: ChartType = 'doughnut';
  public loginDetail:any =[];
  public setIn:any='';
  public seekFeedback = '';
  public currentTime = 0;
  public videoDuration = 0;
  public videoProgress = 0;
  public volume = 1;
  public isMuted = false;
  public playbackRate = 1;
  public showSettings = false;
  public annotationsEnabled = true;
  public sleepTimerMinutes = 0;
  private seekFeedbackTimer: ReturnType<typeof setTimeout> | undefined;
  private sleepTimerId: ReturnType<typeof setTimeout> | undefined;

  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = JSON.parse(localStorage.getItem('grw_login') || "{}");
    this.getData();
    if(localStorage.getItem('grw_first')){
      this.firstview = true;
      this.setIn=setInterval(()=>{
        if(this.audiopath.ended){
          this.firstview=false; 
          clearInterval(this.setIn);
        }  
     }, 2000); 
      localStorage.removeItem('grw_first');
    }
  }

  ngOnInit(): void { 
  
  }

  @HostListener('wheel', ['$event']) onMouseWheel(event: WheelEvent) {
    this.firstview = false;
    clearInterval(this.setIn);
  }

  public chartClicked({ event, active }: { event: ChartEvent, active: {}[] }): void {
    // console.log(event, active);
  }

  public chartHovered({ event, active }: { event: ChartEvent, active: {}[] }): void {
    // console.log(event, active);
  }

  getData(){
  const url = "/dashboard"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) { 
        response.data.cards.filter((el:any)=>{
          if(el.title=='Purchase'){
            el.name = 'PURCHASES';
            el.link ='/purchase';
            el.class='gricon gr_ic_user_fill';
          }
          if(el.title=='Collaboration'){
            el.name = 'COLLABORATIONS';
            el.link ='/partners';
            el.class='gricon gr_ic_users';
          }
          if(el.title=='Program'){
            el.name ='PROGRAMS';
            el.link ='/programs';
            el.class='gricon gr_ic_programs';
          }
          if(el.title=='Streams'){
            el.name ='STREAMS';
            el.link ='/singles';
            el.class='gricon gr_ic_video';
          }
          if(el.title=='Album'){
            el.name ='ALBUMS';
            el.link ='/albums';
            el.class='gricon gr_ic_video_camera';
          }
        })
        var self=this;
        if(response.data.financial.length != 0){
          response.data.financial.filter((el:any)=>{ 
             var ss:any =el.x +' ' +self.loginDetail.userCurrencySymbol + el.y;
             const amount = Number(el.y);
             const formattedAmount = Number.isFinite(amount) ? amount.toFixed(2) : '00.00';
             const category = String(el.x || '').toLowerCase();
             if (category === 'subscription' || category === 'subscriptions') {
               self.ssvalue = formattedAmount;
             }
             if (category === 'program' || category === 'programs') {
               self.ppvalue = formattedAmount;
             }
             if (category === 'referral' || category === 'referrals') {
               self.rrvalue = formattedAmount;
             }
            self.doughnutChartData.labels.push(ss);
            self.doughnutChartData.datasets[0].data.push(el.y);
          })
          self.doughnutChartPlugins = [{
            beforeDraw(chart:any) {
              const ctx = chart.ctx;
              const txt = 'Center Text';        
              //Get options from the center object in options
              const sidePadding = 60;
              const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
        
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
              const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
        
              //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
              const stringWidth = ctx.measureText(txt).width;
              const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
        
              // Find out how much the font can grow in width.
              const widthRatio = elementWidth / stringWidth;
              const newFontSize = Math.floor(30 * widthRatio);
              const elementHeight = (chart.innerRadius * 2);
        
              // Pick a new font size so it will not be larger than the height of label.
              const fontSizeToUse = Math.min(newFontSize, elementHeight);
        
              ctx.font = 13 + 'px Arial Black';
              ctx.fillStyle = '#dc3545';
        
              // Draw text in center
              var ss='Total Revenue:'+ self.loginDetail.userCurrencySymbol  +self.detaildata.totalPurchasedAmount;
              ctx.fillText(ss, centerX, centerY);
            }
          }];
        }
        this.AlbumList=response.data.trending_video;
        if(this.AlbumList.length ==0){
          for(var i:any=1 ; i<9;i++){
            this.b_AlbumList.push(i);
          }
        } else {
          for(var i:any=this.AlbumList.length ; i<9;i++){
            this.b_AlbumList.push(i);
          }
        }    
        this.detaildata=response.data;
        // Do not alter the API result in UAT/production. This local fallback
        this.loading=false;  
        if(self.detaildata.totalPurchasedAmount !=0){
          this.chartShow=true; 
        }        
        this.audiopath = document.getElementById("myAudio");   
      } else {
        this.loading=false;
        for(var i:any=1; i<9;i++){
          this.b_AlbumList.push(i);
        }
      }
    }), (error) => { this.loading =false; });
  }


  redirectCheck(){
    const bypassProfileCheck = environment.bypassProfileCheck ?? false;
    if(bypassProfileCheck || this.loginDetail.profile_complete ==true){
      // if(this.loginDetail.bank_account_added==true){
        this.router.navigate(['/create-post']);
      // } else {
      //   this.service.dangerAlert('Please complete your Bank Detail');
      // }      
    } else {
      this.service.dangerAlert('Please complete your profile first');
      this.router.navigate(['/edit-profile']);
    }
  }

  skip(){
    this.firstview=false; 
    clearInterval(this.setIn);
  }

  plays(){
   var ss:any= this.getDashboardVideo();
   if(!ss || this.isBunnyVideo(this.detaildata?.welcome_video)) return;
   if(ss.paused){
    ss.play();
    this.showButton=false;
   } else {
    ss.pause();
    this.showButton=true;
   }   
  }

  private getDashboardVideo(): HTMLVideoElement | null {
    return document.getElementById('myAudio1') as HTMLVideoElement | null;
  }

  onVideoPlay(): void {
    this.showButton = false;
  }

  onVideoPause(): void {
    this.showButton = true;
  }

  onVideoEnded(): void {
    this.showButton = true;
    this.videoProgress = 100;
  }

  updateVideoProgress(): void {
    const video = this.getDashboardVideo();
    if (!video) return;

    this.currentTime = video.currentTime || 0;
    this.videoDuration = Number.isFinite(video.duration) ? video.duration : 0;
    this.videoProgress = this.videoDuration ? (this.currentTime / this.videoDuration) * 100 : 0;
    this.volume = video.volume;
    this.isMuted = video.muted;
    this.playbackRate = video.playbackRate;
  }

  setVideoProgress(event: Event): void {
    const video = this.getDashboardVideo();
    const progress = Number((event.target as HTMLInputElement).value);
    if (!video || !Number.isFinite(video.duration)) return;

    video.currentTime = (progress / 100) * video.duration;
    this.updateVideoProgress();
  }

  setVolume(event: Event): void {
    const video = this.getDashboardVideo();
    const value = Number((event.target as HTMLInputElement).value);
    if (!video) return;

    video.volume = value;
    video.muted = value === 0;
    this.volume = value;
    this.isMuted = video.muted;
  }

  toggleMute(): void {
    const video = this.getDashboardVideo();
    if (!video) return;

    video.muted = !video.muted;
    this.isMuted = video.muted;
  }

  setPlaybackRate(event: Event): void {
    const video = this.getDashboardVideo();
    const rate = Number((event.target as HTMLSelectElement).value);
    if (!video || !Number.isFinite(rate)) return;

    video.playbackRate = rate;
    this.playbackRate = rate;
  }

  setSleepTimer(event: Event): void {
    const minutes = Number((event.target as HTMLSelectElement).value);
    if (this.sleepTimerId) clearTimeout(this.sleepTimerId);
    this.sleepTimerMinutes = minutes;
    if (!minutes) return;

    this.sleepTimerId = setTimeout(() => {
      const video = this.getDashboardVideo();
      video?.pause();
      this.sleepTimerMinutes = 0;
    }, minutes * 60 * 1000);
  }

  toggleFullscreen(): void {
    const player = document.querySelector('.dashboard-video-box') as HTMLElement | null;
    if (!player) return;

    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      player.requestFullscreen();
    }
  }

  formatVideoTime(value: number): string {
    if (!Number.isFinite(value) || value < 0) return '0:00';
    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  }


  seekVideo(seconds: number): void {
    const video = this.getDashboardVideo();
    if (!video || !Number.isFinite(video.duration)) return;

    video.currentTime = Math.max(0, Math.min(video.duration, video.currentTime + seconds));
  }

  seekFromDoubleClick(event: MouseEvent): void {
    if (this.isBunnyVideo(this.detaildata?.welcome_video)) return;

    const player = event.currentTarget as HTMLElement;
    const bounds = player.getBoundingClientRect();
    const relativeX = event.clientX - bounds.left;
    const skip = relativeX < bounds.width / 2 ? -10 : 10;
    this.seekVideo(skip);

    this.seekFeedback = skip < 0 ? '↺ 10 seconds' : '10 seconds ↻';
    if (this.seekFeedbackTimer) clearTimeout(this.seekFeedbackTimer);
    this.seekFeedbackTimer = setTimeout(() => this.seekFeedback = '', 700);
  }
}
